export function emptyBin() {
  return {
    materials: [],
    totalPrice: 0,
    totalQuantity: 0,
    validationStatus: false,
    selectedAgent: null,
    items: [],
  };
}

export function binFromPayload(payload) {
  if (!payload) return emptyBin();
  const raw = payload.data?.bin || payload.bin || payload;
  if (!raw || typeof raw !== "object") return emptyBin();
  return {
    ...raw,
    materials: raw.materials || [],
    totalPrice: raw.totalPrice ?? 0,
    totalQuantity: raw.totalQuantity ?? 0,
    validationStatus: !!raw.validationStatus,
    selectedAgent: raw.selectedAgent ?? null,
    items: raw.items || [],
  };
}

export { queryKeys } from "./keys";

export function binQuantity(bin) {
  return (bin?.materials || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
}
